export default __webpack_public_path__ + "static/whatsbutton-16c113eb44f3222036805c26ce6f9695.svg";